
define('text!modules/targeting/audience/templates/bin_header.html',[],function () { return '<div class="column header size">\n\t<div class="header-c">size</div>\n</div>\n<div class="column header cpm">\n\t<div class="header-c">cpm</div>\n</div>';});

